import { Match, MatchType, RouterContext } from "@cdv/jazz-ui";
import { Box } from "@mui/material";
import { ReactElement, useContext, useEffect } from "react";
import { useSync } from "./Sync";

export default function Outlet(): ReactElement {
  const context = useContext(RouterContext);
  const key = JSON.stringify(context);

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [key]);

  return (
    <Box key={key} sx={{ width: "100%", height: "100%" }}>
      <Match type={MatchType.View} params={context} />
    </Box>
  );
}
